import { Container } from 'react-bootstrap';

export default function About() {
  return (
    <Container className="text-center">
        <p>
          About under construction!
        </p>
    </Container>
  );
}